const connectedProducts = document.querySelectorAll(".connected-products__products img");
const currentColor = document.querySelector(".connected-products__color")?.dataset.currentColor;

if(!connectedProducts.length) return;

connectedProducts.forEach((product) => {
  product.addEventListener("mouseenter", function () {
    const color = this.dataset.color;
    document.querySelector(".connected-products__color span").textContent = color;
  });

  product.addEventListener("mouseleave", function () {
    document.querySelector(".connected-products__color span").textContent = currentColor;
  });
});





// Thumbnails and swatches
import Flickity from 'flickity';

let cards = document.querySelectorAll('.product-item');
cards.forEach((card) => {

  let container = card.querySelector('.connected-products');
  let target = card.querySelector('.connected-products__products');

  card.addEventListener("mouseenter", function () {

    // If thumbnails are overflowing, initialize flickity carousel
    if( target.scrollWidth > container.offsetWidth ) {
      let flky = new Flickity( target, {
        cellAlign: 'left',
        pageDots: false
      });
    }
    
  });
});

// color inidcators sync - swatches and thumbnails
let indicators = document.querySelectorAll('.color-selection-indicators');

indicators.forEach((indicator) => {
  let options = indicator.querySelectorAll('.color-indicators__item, .connected-products__products-item');
  options.forEach((option) => {
    option.addEventListener('click', function(event){
      const clickedElement = event.target;

      let img1 = option.dataset.img1;
      let img2 = option.dataset.img2;
      let url = option.dataset.url;
      
      // Find the closest parent with the specified class
      const closestParent = clickedElement.closest('.product-item');
      closestParent.dataset.activeProductId = option.dataset.productId;

      // Update card elements to selected color - images and links
      closestParent.querySelector('.product-item__image-link').href = url;
      closestParent.querySelector('.product-item__product-title a').href = url;
      closestParent.querySelector('.product-item__image--one img').removeAttribute('srcset');
      closestParent.querySelector('.product-item__image--two img').removeAttribute('srcset');
      closestParent.querySelector('.product-item__image--one img').src = img1;
      closestParent.querySelector('.product-item__image--two img').src = img2;

      // Change selected thumbnail indicator
      closestParent.querySelector('.connected-products__products-item--selected').classList.remove('connected-products__products-item--selected');
      closestParent.querySelector(`[data-product-id="${option.dataset.productId}"]`).classList.add('connected-products__products-item--selected');
     
    });
  });
});